/* unplugin-vue-components disabled */import script from "./Resources.vue?vue&type=script&setup=true&lang=js"
export * from "./Resources.vue?vue&type=script&setup=true&lang=js"

import "./Resources.vue?vue&type=style&index=0&id=5e5323a4&scoped=true&lang=scss"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e5323a4"]])

export default __exports__